import React from 'react';
import { Typography } from '@mui/material';
import { getUsageLimitLabel } from '../utils/formatUsageDisplay';

export default function MeterUsageLine({ meter_name, usage, limit, nameColor = 'text.primary' }) {
  const limitLabel = getUsageLimitLabel(limit);

  return (
    <Typography component="span" variant="body2" color={nameColor}>
      {meter_name}{' '}
      <Typography component="span" variant="caption" color="text.secondary">
        ({usage} / {limitLabel})
      </Typography>
    </Typography>
  );
}
